import { useEffect, useState } from "react";
import Input from "../../Components/Input";

const ScoringModal = ({ dataTask, register, reset }) => {
	// useEffect(() => {
	//   if (dataTask) {
	//     const oldData = dataTask?.contributor;
	//     let bodyRequest = {};
	//     bodyRequest = {
	//       score: oldData?.map((item)=>(parseInt(item?.score))),
	//     };
	//     reset(bodyRequest);
	//   }
	// }, [dataTask]);

	return (
		<div>
			{dataTask?.contributor?.map((item, index) => (
				<div className="mb-5 flex items-center gap-5" key={index}>
					<div>
						<Input
							id={`score[${item?.id}]`}
							placeholder="Input Score"
							required
							type="number"
							{...register(`score[${item?.id}]`, {
								valueAsNumber: true,
								onChange: (e) => {
									const val = parseInt(e.target.value, 10);

									// Jika tidak angka, atau di luar 0–5, ubah jadi 0
									if (isNaN(val) || val < 0 || val > 6) {
										e.target.value = "";
									}
								},
							})}
						/>
					</div>
					<div>
						<label htmlFor={`score[${item?.id}]`} className="block mb-3">
							: {item?.user?.name}
						</label>
					</div>
				</div>
			))}
		</div>
	);
};

export default ScoringModal;
